import { PartList } from 'services/availabilityBySource/types';

export const getPartsList = (products: Product[]): PartList[] =>
  products?.map((item) => {
    return {
      partNumber: item?.partNumber,
      quantity: 1,
      sosCode: item?.sosCode ?? null
    };
  });
